import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postOutboundResync = createApi(`OutboundResyncSlice`,"POST");

const OutboundResyncSlice = createSlice({
  name: 'OutboundResyncSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postOutboundResync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postOutboundResync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postOutboundResync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default OutboundResyncSlice.reducer;